var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Counter',{attrs:{"incr":_vm.incr,"decr":_vm.decr,"currentCount":_vm.CounterInstance.currentCount,"delta":2}})}
var staticRenderFns = []

export { render, staticRenderFns }